module.exports = __webpack_public_path__ + "static/texts/andres.c7fa89b.asc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pubkeys/andres.asc
// module id = 5X6Q
// module chunks = 0